import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { parisNow } from "@/lib/parisTime";

const pad = (n) => String(n).padStart(2, "0");

export const ScheduleCard = ({ value, onChange }) => {
  const time = value ? `${pad(value.getHours())}:${pad(value.getMinutes())}` : "09:00";

  const setDate = (day) => {
    if (!day) return onChange(null);
    const [h, m] = time.split(":").map(Number);
    const d = new Date(day);
    d.setHours(h, m, 0, 0);
    onChange(d);
  };

  const setTime = (t) => {
    if (!value || !t) return;
    const [h, m] = t.split(":").map(Number);
    const d = new Date(value);
    d.setHours(h, m, 0, 0);
    onChange(d);
  };

  return (
    <Card className="border-0 bg-white rounded-2xl soft-shadow" data-testid="schedule-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-heading text-[#1E2A5A] flex items-center gap-2">
          <CalendarIcon className="w-4 h-4" />
          Date de publication
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-center rounded-xl border border-gray-200">
        <Calendar
          mode="single"
          locale={fr}
          selected={value || undefined}
          onSelect={setDate}
          disabled={{ before: new Date(parisNow().setHours(0, 0, 0, 0)) }}
          data-testid="schedule-calendar"
        />
        </div>
        <div className="space-y-1">
          <Label className="text-sm text-[#6B7280]">Heure (heure de Paris)</Label>
          <Input
            type="time"
            value={time}
            disabled={!value}
            onChange={(e) => setTime(e.target.value)}
            data-testid="schedule-time-input"
            className="rounded-xl border-gray-200 focus:border-[#20C997] focus:ring-[#20C997]"
          />
        </div>
        {value ? (
          <div className="flex items-center justify-between rounded-xl bg-[#20C997]/10 px-3 py-2">
            <span className="text-sm text-[#1E2A5A]" data-testid="schedule-summary">
              {format(value, "EEEE d MMMM yyyy 'à' HH:mm", { locale: fr })} (Paris)
            </span>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 text-[#6B7280] hover:text-red-500"
              onClick={() => onChange(null)}
              data-testid="schedule-clear-btn"
            >
              <X className="w-3 h-3" />
            </Button>
          </div>
        ) : (
          <p className="text-xs text-[#6B7280]">Choisissez une date pour planifier, sinon publication immédiate.</p>
        )}
      </CardContent>
    </Card>
  );
};
